/**
 * What this application hands the vendored feedback panel (src/vendor/feedback,
 * copied from DepicomNLBV/platform-feedback; never edited here).
 *
 * Its own module rather than constants in App.tsx so a test can read it.
 */
import { matchPath } from "react-router-dom";

import { session } from "./auth/session";

/** Where api/main.py mounts the module's router. */
export const FEEDBACK_API_BASE = "/api/feedback";

/**
 * The addresses `Screens` in App.tsx routes, as patterns. A report carries the
 * pattern and never the address: `/runs/:runId/days/:date`, not
 * `/runs/11/days/2026-10-01`, or one screen would scatter over a hundred rows
 * in the triage queue.
 */
const SCREENS = [
  "/plan",
  "/runs",
  "/runs/:runId/weeks/:monday",
  "/runs/:runId/days/:date",
  "/closures",
  "/sales",
  "/to-do",
  "/trading",
  "/milk-flow",
  "/milk-flow/days/:date",
  "/milk-flow/block-days",
  "/milk-flow/farms/:producer",
] as const;

/** The screen a report was sent from, as its pattern; "not-found" for any other address. */
export function screenPattern(pathname: string): string {
  if (pathname === "/") return "/";
  return SCREENS.find((pattern) => matchPath(pattern, pathname)) ?? "not-found";
}

/** The planner's own token, asked for per call so a renewal reaches the panel. */
export async function feedbackToken(): Promise<string> {
  return (await session.accessToken()) ?? "";
}
